import { Col, Row } from "antd";
import React, { useState } from "react";
import { Button, Picker, Text, TextField } from "../../components";
import {
    MontserratBold,
    MontserratMedium,
    PoppinsMedium,
} from "../../config/fonts";
import { Colors, Fonts } from "../../config";
import { CloseCircleOutlined, InboxOutlined } from "@ant-design/icons";
import Dragger from "antd/es/upload/Dragger";
import { useDispatch, useSelector } from "react-redux";
import { AdsAction } from "../../store/actions";
import { MdClose } from "react-icons/md";
import moment from "moment";

const CreateAd = ({ closeModal }) => {
    const dispatch = useDispatch();
    const ad = useSelector((state) => state.ads);

    const [state, setState] = useState({
        file: null,
        startDate: null,
        endDate: null,
        title: "",
        description: "",
        receiptData: "",
        transactionId: "",
        paymentMethod: "admin-granted",
        paid: "",
    });

    const [error, setError] = useState({
        fileError: "",
        startDateError: "",
        endDateError: "",
        titleError: "",
        descriptionError: "",
        receiptDataError: "",
        transactionIdError: "",
        paidError: "",
    });


    const handleFileChange = (info) => {
        const file = info?.file?.originFileObj || info?.file;

        if (file) {
            setState({
                ...state,
                file: file,
            });
            setError({
                ...error,
                fileError: "",
            });
        }
    };

    const handleDateChange = (date, fieldName) => {
        setState({
            ...state,
            [fieldName]: date,
        });

        setError({
            ...error,
            [fieldName + "Error"]: "",
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        setState({
            ...state,
            [name]: value,
        });

        setError({
            ...error,
            [name + "Error"]: "",
        });
    };

    const generateUniqueId = () => {
        return `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    };

    const validateForm = () => {
        let isValid = true;
        let errors = {};

        if (!state.file) {
            errors.fileError = "File is required";
            isValid = false;
        }

        if (!state.startDate) {
            errors.startDateError = "Start date is required";
            isValid = false;
        }

        if (!state.endDate) {
            errors.endDateError = "End date is required";
            isValid = false;
        }

        if (!state.title) {
            errors.titleError = "Title is required";
            isValid = false;
        }

        if (!state.description) {
            errors.descriptionError = "Description is required";
            isValid = false;
        }

        if (!state.paid || parseFloat(state.paid) <= 0) {
            errors.paidError = "Paid amount must be greater than 0";
            isValid = false;
        }

        setError({ ...error, ...errors });
        return isValid;
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            // Generate unique receipt_data and transaction_id
            const receiptData = generateUniqueId();
            const transactionId = generateUniqueId();

            let apiData = {
                file: state.file,
                start_date: state.startDate ? moment(state.startDate).format("DD-MM-YYYY") : "",
                end_date: state.endDate ? moment(state.endDate).format("DD-MM-YYYY") : "",
                title: state.title,
                description: state.description,
                receipt_data: receiptData,
                transaction_id: transactionId,
                payment_method: state.paymentMethod,
                paid: parseFloat(state.paid),
            };

            dispatch(
                AdsAction.createAds(apiData, (res) => {
                    closeModal();
                    handleReset();
                    dispatch(
                        AdsAction.getAdsListing({
                            limit: 10,
                            offset: 0,
                            keyword: "",
                            status: "",
                        })
                    );
                })
            );
        }
    };

    const handleReset = () => {
        setState({
            file: null,
            startDate: null,
            endDate: null,
            title: "",
            description: "",
            receiptData: "",
            transactionId: "",
            paymentMethod: "admin-granted",
            paid: "",
        });

        setError({
            fileError: "",
            startDateError: "",
            endDateError: "",
            titleError: "",
            descriptionError: "",
            receiptDataError: "",
            transactionIdError: "",
            paidError: "",
        });
    };

    const props = {
        name: "file",
        multiple: false,
        maxCount: 1,
        beforeUpload: () => false,
        onChange: handleFileChange,
        onDrop: handleFileChange,
        showUploadList: false,
        fileList: state.file ? [state.file] : [],
    };

    return (
        <div className="create-ad-modal">
            <Row justify={"space-between"} className="mb-20">
                <Col>
                    <Text.Basic
                        color={Colors.Black}
                        fontSize={22}
                        fontWeight={600}
                        fontFamily={Fonts[MontserratBold]}
                        text={"Create Ad"}
                        textAlign="left"
                    />
                </Col>
                <Col>
                    <MdClose
                        color={Colors.Black}
                        fontSize={24}
                        cursor={"pointer"}
                        onClick={closeModal}
                    />
                </Col>
            </Row>

            <Row gutter={[25, 25]} className="mb-20">
                <Col span={24}>
                    <Text.Basic
                        fontSize={18}
                        fontWeight={600}
                        fontFamily={Fonts[MontserratBold]}
                        text={"File *"}
                        textAlign="left"
                    />
                    {/* <Dragger {...props} className="mt-10">
                        {!state.file ? <>
                            <p className="ant-upload-drag-icon">
                                <InboxOutlined />
                            </p>
                            <p className="ant-upload-text">
                                Click or drag file to this area to upload
                            </p></> : <div>File Selected</div>}
                    </Dragger> */}
                    <Dragger {...props} className="mt-10">
                        {!state.file ? (
                            <>
                                <p className="ant-upload-drag-icon">
                                    <InboxOutlined />
                                </p>
                                <p className="ant-upload-text">
                                    Click or drag file to this area to upload
                                </p>
                            </>                        ) : (
                            <div style={{ textAlign: "center" }}>
                                {/* IMAGE PREVIEW */}
                                {state.file.type?.startsWith("image/") && (
                                    <img
                                        src={URL.createObjectURL(state.file)}
                                        alt="Preview"
                                        style={{
                                            width: "100%",
                                            borderRadius: "10px",
                                        }}
                                        className="object-fit-contain"
                                    />
                                )}

                                {/* VIDEO PREVIEW */}
                                {state.file.type?.startsWith("video/") && (
                                    <video
                                        src={URL.createObjectURL(state.file)}
                                        controls
                                        style={{
                                            width: "100%",
                                            maxHeight: "200px",
                                            borderRadius: "10px",
                                        }}
                                    />
                                )}

                                {/* PDF PREVIEW */}
                                {state.file.type === "application/pdf" && (
                                    <>
                                        <InboxOutlined style={{ fontSize: 40 }} />
                                        <p className="mt-10">{state.file.name}</p>
                                    </>
                                )}

                            </div>
                        )}
                    </Dragger>

                    {state.file && (
                        <div className="mt-10 flex-row-space-between flex-row-align-center">
                            <p className="m-0">{state.file.name}</p>
                            <span
                                onClick={() =>
                                    setState({ ...state, file: null })
                                }
                                style={{ cursor: "pointer" }}
                            >
                                <CloseCircleOutlined />
                            </span>
                        </div>
                    )}
                    {error.fileError && <Text.Error text={error.fileError} />}
                </Col>

                <Col span={12}>
                    <div>
                        <Text.Basic
                            fontSize={16}
                            fontWeight={600}
                            fontFamily={Fonts[MontserratMedium]}
                            text="Start Date *"
                            textAlign="left"
                            className="mb-10"
                        />
                        <Picker.DatePicker
                            containerStyle={{ width: "100%" }}
                            style={{ width: "100%", height: "45px" }}
                            size="large"
                            format="DD-MM-YYYY"
                            placeholder="DD-MM-YYYY"
                            value={state.startDate}
                            onChange={(date) => handleDateChange(date, "startDate")}
                        />
                        {error.startDateError && <Text.Error text={error.startDateError} />}
                    </div>
                </Col>

                <Col span={12}>
                    <div>
                        <Text.Basic
                            fontSize={16}
                            fontWeight={600}
                            fontFamily={Fonts[MontserratMedium]}
                            text="End Date *"
                            textAlign="left"
                            className="mb-10"
                        />
                        <Picker.DatePicker
                            containerStyle={{ width: "100%" }}
                            style={{ width: "100%", height: "45px" }}
                            size="large"
                            format="DD-MM-YYYY"
                            placeholder="DD-MM-YYYY"
                            value={state.endDate}
                            onChange={(date) => handleDateChange(date, "endDate")}
                        />
                        {error.endDateError && <Text.Error text={error.endDateError} />}
                    </div>
                </Col>

                <Col span={24}>
                    <TextField.Basic
                        label="Title *"
                        labelFontWeight={600}
                        labelFontFamily={Fonts[MontserratMedium]}
                        size={"large"}
                        placeholder="Enter ad title"
                        value={state.title}
                        onChange={handleChange}
                        name="title"
                        errorText={error.titleError && error.titleError}
                    />
                </Col>

                <Col span={24}>
                    <TextField.Basic
                        label="Description *"
                        labelFontWeight={600}
                        labelFontFamily={Fonts[MontserratMedium]}
                        size={"large"}
                        placeholder="Enter ad description"
                        value={state.description}
                        onChange={handleChange}
                        name="description"
                        errorText={error.descriptionError && error.descriptionError}
                    />
                </Col>

                <Col span={12}>
                    <TextField.Basic
                        label="Payment Method"
                        labelFontWeight={600}
                        labelFontFamily={Fonts[MontserratMedium]}
                        size={"large"}
                        value={state.paymentMethod}
                        name="paymentMethod"
                        disabled={true}
                    />
                </Col>

                <Col span={12}>
                    <TextField.Basic
                        label="Paid Amount *"
                        labelFontWeight={600}
                        labelFontFamily={Fonts[MontserratMedium]}
                        size={"large"}
                        placeholder="Enter amount (must be > 0)"
                        value={state.paid}
                        onChange={handleChange}
                        name="paid"
                        type="number"
                        errorText={error.paidError && error.paidError}
                    />
                </Col>

                <Col span={24}>
                    <Button.Basic
                        size={"large"}
                        buttonStyle={{
                            backgroundColor: Colors.BlueText,
                            color: Colors.White,
                            width: "100%",
                            height: "50px",
                            fontSize: "16px",
                            fontFamily: Fonts[PoppinsMedium],
                            borderRadius: "10px",
                            border: "none",
                        }}
                        loading={ad?.createAdsLoader}
                        disabled={ad?.createAdsLoader}
                        text={"Create Ad"}
                        onClick={handleSubmit}
                    />
                </Col>
            </Row>
        </div>
    );
};

export default CreateAd;
